(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Client.Finances",
                {
                    url: "/Finances",
                    component: "finances",
                    resolve: {
                        finance: ["client", "financeApi", function (client, financeApi) {
                            return financeApi.getClientFinance(client.Id);
                        }],
                        otherFinances: ["finance", "financeApi", function (finance, financeApi) {
                            return financeApi.getOtherFinances(finance.Id);
                        }],
                        employmentStatuses: ["employmentStatuses", function (employmentStatuses) {
                            return employmentStatuses;
                        }],
                        taxFilingStatuses: ["taxFilingStatuses", function (taxFilingStatuses) {
                            return taxFilingStatuses;
                        }]
                    },
                    data: {
                        pageTitle: "Finances"
                    }
                });
        }
    ]);

    app.component("finances",
        {
            templateUrl: "/App/Client/Finances/finances-template.html",
            controller: financesController,
            bindings: {
                finance: "<",
                otherFinances: "<",
                employmentStatuses: "<",
                taxFilingStatuses: "<"
            }
        });

    financesController.$inject = ["_", "$rootScope", "financeApi"];
    function financesController(_, $rootScope, financeApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                chartColors: [
                    {
                        backgroundColor: "rgb(53,87,112)",
                        pointBackgroundColor: "rgb(53,87,112)",
                        borderColor: "rgb(53,87,112)",
                        pointBorderColor: "#fff",
                        pointHoverBorderColor: "rgb(53,87,112)"
                    },
                    {
                        backgroundColor: "rgba(7,168,153, 1)",
                        pointBackgroundColor: "rgba(7,168,153, 1)",
                        borderColor: "rgb(7,168,153)",
                        pointBorderColor: "#fff",
                        pointHoverBorderColor: "rgb(7,168,153)"
                    }
                ],
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: true,
                    legend: {
                        display: true,
                        position: "bottom"
                    },
                    tooltips: {
                        enabled: false
                    },
                    hoverBackgroundColor: "#ffffff"
                },
                ui: {
                    expanded: {
                        assets: false,
                        liabilities: false,
                        incomes: false,
                        expenses: false
                    },
                    totals: {}
                },
                addOtherFinance: addOtherFinance,
                updateTotals: updateTotals,
                removeOtherFinance: removeOtherFinance
            });

        $rootScope.$on("loadingClientSubstate",
            function () {
                $ctrl.ui.loading = true;
            });

        $ctrl.updateFinance = _.debounce(function() {
            $ctrl.ui.saving = true;

            financeApi.update($ctrl.finance.Id, $ctrl.finance).then(function() {
                $ctrl.ui.saving = false;
            });
        });

        $ctrl.updateAssets = _.debounce(
            function () {
                $ctrl.ui.saving = true;
                updateTotals();

                financeApi.updateAssets($ctrl.finance.Id, $ctrl.finance).then(function () {
                    $ctrl.ui.saving = false;
                });
            },
            350, {leading: false, trailing: true});

        $ctrl.updateLiabilities = _.debounce(
            function () {
                $ctrl.ui.saving = true;
                updateTotals();

                financeApi.updateLiabilities($ctrl.finance.Id, $ctrl.finance).then(function () {
                    $ctrl.ui.saving = false;
                });
            },
            350);

        $ctrl.updateMonthlyIncomes = _.debounce(
            function () {
                $ctrl.ui.saving = true;
                updateTotals();

                financeApi.updateMonthlyIncomes($ctrl.finance.Id, $ctrl.finance).then(function () {
                    $ctrl.ui.saving = false;
                });
            },
            350);

        $ctrl.updateMonthlyExpenses = _.debounce(
            function () {
                $ctrl.ui.saving = true;
                updateTotals();

                financeApi.updateMonthlyExpenses($ctrl.finance.Id, $ctrl.finance).then(function () {
                    $ctrl.ui.saving = false;
                });
            },
            350);

        function removeOtherFinance(otherFinanceId) {
            financeApi.removeOtherFinance($ctrl.finance.Id, otherFinanceId)
                .then(function (response) {
                    _.remove($ctrl.otherFinances,
                        function(otherFinance) {
                            return otherFinance.Id === otherFinanceId;
                        });
                    updateTotals();
            });
        }

        function addOtherFinance(financeType) {
            $ctrl.ui.saving = true;
            var otherFinance = { Type: financeType };

            switch (financeType) {
                case "Asset":
                    otherFinance.Name = $ctrl.newAssetName;
                    $ctrl.newAssetName = "";
                    break;
                case "Liability":
                    otherFinance.Name = $ctrl.newLiabilityName;
                    $ctrl.newLiabilityName = "";
                    break;
                case "MonthlyIncome":
                    otherFinance.Name = $ctrl.newIncomeName;
                    $ctrl.newIncomeName = "";
                    break;
                case "MonthlyExpense":
                    otherFinance.Name = $ctrl.newExpenseName;
                    $ctrl.newExpenseName = "";
                    break;
            }

            $ctrl.otherFinances.push(otherFinance);
            financeApi.addOtherFinance($ctrl.finance.Id, otherFinance).then(function (response) {
                otherFinance.Id = response.Id;
                $ctrl.ui.saving = false;
            });
        }

        $ctrl.updateOtherFinance = _.debounce(
            function (otherFinance) {
                $ctrl.ui.saving = true;
                updateTotals();

                financeApi.updateOtherFinance($ctrl.finance.Id, otherFinance.Id, otherFinance).then(function () {
                    $ctrl.ui.saving = false;
                });
            },
            350);

        function addFinanceValues(result, value) {
            return result + (value || 0);
        }

        function computeFinancialTotals(finances, financeType, otherFinances) {
            return _
                .chain(otherFinances)
                .filter({ Type: financeType })
                .sumBy('Value')
                .value() +
                _.reduce(finances, addFinanceValues, 0);

        }

        function updateTotals() {

            $ctrl.ui.totals.assets = computeFinancialTotals($ctrl.finance.Assets, "Asset", $ctrl.otherFinances);
            $ctrl.ui.totals.liabilities = computeFinancialTotals($ctrl.finance.Liabilities, "Liability", $ctrl.otherFinances);
            $ctrl.ui.totals.incomes = computeFinancialTotals($ctrl.finance.MonthlyIncomes, "MonthlyIncome", $ctrl.otherFinances);
            $ctrl.ui.totals.expenses = computeFinancialTotals($ctrl.finance.MonthlyExpenses, "MonthlyExpense", $ctrl.otherFinances);

            $ctrl.ui.assetLiabilityData = !!$ctrl.ui.totals.assets > 0 || !!$ctrl.ui.totals.liabilities > 0
                ? [$ctrl.ui.totals.assets, $ctrl.ui.totals.liabilities]
                : [1, 1];
            $ctrl.ui.incomeExpenseData = !!$ctrl.ui.totals.incomes > 0 || !!$ctrl.ui.totals.expenses > 0
                ? [$ctrl.ui.totals.incomes, $ctrl.ui.totals.expenses]
                : [1, 1];
        }

        $ctrl.$onInit = () => {
            updateTotals();
        }
    }

})(window.app, window.angular); //jshint ignore:line